import React, { useState } from "react";
import "./Explore_Banner.css";
import Download_Btn from "../../common/download-btn/Download_Btn";
import Apply_Modal from "../../apply-modal/Apply_Modal";
import { IDS } from "../../../utils/IDS";

const Explore_Banner = ({ program }) => {
  const [show, setShow] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const bannerSrc = program?.banner ? `${IDS.IMG_URL}${program.banner}` : null;

  // : "/assets/images/explore_program/explore-banner.png";

  const img = program?.banner;
  const curriculumPdfUrl = program?.curriculum_pdf
    ? `${IDS.IMG_URL}${program.curriculum_pdf}`
    : null;

  return (
    <section className="Explore_Banner">
      <div className=" banner_image_div container-fluid p-0">
        {!imageLoaded && <div className="shimmer_loader" />}
        <img
          src={bannerSrc}
          alt={program?.name || "Program Banner"}
          onLoad={() => setImageLoaded(true)}
          className={`banner_img ${imageLoaded ? "visible" : "hidden"}`}
        />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-7">
            <div className="banner_content_div">
              <h5 className="banner_title">Become a Job-Ready</h5>
              <h5 className="banner_subtitle">{program?.name}</h5>
              {/* <p className="banner_text">{program?.overview?.slice(0, 150)}</p> */}

              <p
                className="banner_text"
                dangerouslySetInnerHTML={{
                  __html: program?.overview?.slice(0, 150) + "...",
                }}
              />

              {/* <p className="banner_text">
                {stripHtml(program?.overview).slice(0, 120)}...
              </p> */}

              <p className="dual_text">
                {" "}
                Duration: <span>{program?.duration}</span>{" "}
              </p>
              {/* <p className="dual_text">
                Mode: <span>Live Online + Hands-On Projects</span>
              </p>
              <p className="dual_text">
                Level: <span>Beginner to Advanced</span>
              </p> */}

              <div className="banner_btn_holder">
                <button className="enroll_btn" onClick={() => setShow(true)}>
                  Enroll Now
                </button>
                <Download_Btn
                  text="Download Curriculum"
                  onClick={() => {
                    if (curriculumPdfUrl) {
                      window.open(curriculumPdfUrl, "_blank");
                    } else {
                      alert(
                        "Curriculum PDF is not available for this program.",
                      );
                    }
                  }}
                  disabled={!curriculumPdfUrl}
                />
              </div>
            </div>
          </div>

          {/* <div className="col-lg-7 col-md-5 banner_image_div">
            {!imageLoaded && <div className="shimmer_loader" />}
            <img
              src={bannerSrc}
              alt={program?.name || "Program Banner"}
              onLoad={() => setImageLoaded(true)}
              className={`banner_img ${imageLoaded ? "visible" : "hidden"}`}
            />
          </div> */}
        </div>
      </div>

      <Apply_Modal show={show} handleClose={() => setShow(false)} />
    </section>
  );
};

export default Explore_Banner;
